import { HttpErrorResponse } from '@angular/common/http';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const isHttpError = (err: any) => err instanceof HttpErrorResponse;
